import * as yup from 'yup';

export const formSchema = yup.object({
  updateType: yup
    .mixed<'pointsRewarded' | 'pointsDeducted'>()
    .default('pointsRewarded')
    .required('select either add or remove points'),
  userActionType: yup
    .string()
    .required('select a reason type'),
  availablePoints: yup.number(),
  adminComments: yup.string(),
  uidCode: yup
    .string()
    .when('userActionType', ([userActionType], schema) => {
      return userActionType === 'PRODUCT_SCAN'
        ? schema.required('please enter uid code')
        : schema;
    }),
  isUidVerified: yup
    .boolean()
    .default(false)
    .when('userActionType', ([userActionType], schema) => {
      return userActionType === 'PRODUCT_SCAN'
        ? schema.test(
            'uidVerify',
            'please verify the uid code',
            (val) => val
          )
        : schema;
    }),
  points: yup
    .number()
    .required('please enter a number to add/remove points')
    .typeError('please enter a number'),
});

export type TFormData = yup.InferType<typeof formSchema>;
